import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MomentModule } from 'angular2-moment';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxGaugeModule } from 'ngx-gauge';
import { ChartModule } from 'primeng/chart';
import { DataViewModule } from 'primeng/dataview';
import { InputSwitchModule } from 'primeng/inputswitch';
import { OrderListModule } from 'primeng/orderlist';
import {
    AutoCompleteModule,
    ButtonModule, CalendarModule, CardModule, CarouselModule, CheckboxModule,
    ChipsModule,
    ColorPickerModule,
    ConfirmDialogModule,
    ConfirmationService,
    ContextMenuModule, DataTableModule, DialogModule, DropdownModule, EditorModule, FileUploadModule, GrowlModule, InputMaskModule,
    InputTextModule,
    InputTextareaModule,
    ListboxModule, MegaMenuModule,
    MenuModule, MessageModule, MessagesModule, MultiSelectModule, OverlayPanelModule, PanelModule, PasswordModule, ProgressBarModule, ProgressSpinnerModule, ScrollPanelModule, SelectButtonModule, SharedModule, SlideMenuModule,
    SliderModule,
    StepsModule, TabMenuModule, TabViewModule, ToolbarModule, TooltipModule, TreeDragDropService, TreeModule
} from 'primeng/primeng';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { FeedbackService } from './services/user/feedback.service';
import { AppComponent } from './app.component';
import { AppMenuComponent, AppSubMenuComponent } from "./app.menu.component";
import { AppSideBarComponent } from "./app.sidebar.component";
import { AppSideBarTabContentComponent } from "./app.sidebartabcontent.component";
import { AppTopBarComponent } from "./app.topbar.component";
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { UserDashboardComponent } from './components/admin/user-dashboard/user-dashboard.component';
import { WeeklyDashboardComponent } from './components/admin/weekly-dashboard/weekly-dashboard.component';
import { AdvertsCreateComponent } from './components/adverts/adverts-create/adverts-create.component';
import { AdvertsEditComponent } from './components/adverts/adverts-edit/adverts-edit.component';
import { AdvertsComponent } from './components/adverts/adverts.component';
import { AssetComponent } from './components/asset/asset.component';
import { CreateAssetComponent } from './components/asset/create-asset/create-asset.component';
import { EditAssetComponent } from './components/asset/edit-asset/edit-asset.component';
import { BookCreateComponent } from './components/book/book-create/book-create.component';
import { BookEditComponent } from './components/book/book-edit/book-edit.component';
import { BookComponent } from './components/book/book.component';
import { BusinessCategoryCreateComponent } from './components/business/business-category/business-category-create/business-category-create.component';
import { BusinessCategoryEditComponent } from './components/business/business-category/business-category-edit/business-category-edit.component';
import { BusinessCategoryComponent } from './components/business/business-category/business-category.component';
import { CategoryGroupCreateComponent } from './components/business/business-category/category-group/category-group-create/category-group-create.component';
import { CategoryGroupEditComponent } from './components/business/business-category/category-group/category-group-edit/category-group-edit.component';
import { CategoryGroupComponent } from './components/business/business-category/category-group/category-group.component';
import { BusinessProfileCreateComponent } from "./components/business/business-profile/business-profile-create.component";
import { BusinessProfileComponent } from './components/business/business-profile/business-profile/business-profile/business-profile.component';
import { CampaignsCreateComponent } from './components/campaigns/campaigns-create/campaigns-create.component';
import { CampaignsEditComponent } from './components/campaigns/campaigns-edit/campaigns-edit.component';
import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { UploadComponent } from './components/content/upload/upload.component';
import { CouponsCreateComponent } from './components/coupons/coupons-create/coupons-create.component';
import { CouponsEditComponent } from './components/coupons/coupons-edit/coupons-edit.component';
import { CouponsComponent } from './components/coupons/coupons.component';
import { AccessDeniedFullComponent } from './components/error/access-denied-full/access-denied-full.component';
import { AccessDeniedComponent } from './components/error/access-denied/access-denied.component';
import { PageNotFoundComponent } from './components/error/page-not-found.component';
import { EventEditComponent } from './components/events/event-edit/event-edit.component';
import { ManageFeedbackComponent } from './components/feedback/manage/manage-feedback/manage-feedback.component';
import { CreateFlashCouponComponent } from './components/flash/flash-coupons/create-flash-coupon/create-flash-coupon.component';
import { EditFlashCouponComponent } from './components/flash/flash-coupons/edit-flash-coupon/edit-flash-coupon.component';
import { FlashCouponsComponent } from './components/flash/flash-coupons/flash-coupons.component';
import { FlashProductGroupComponent } from './components/flash/groups/flash-product-group.component';
import { EditFlashGroupComponent } from './components/flash/groups/group-edit/edit-flash-group.component';
import { FlashProductComponent } from './components/flash/products/flash-product.component';
import { FlashProductEditComponent } from './components/flash/products/product-edit/flash-product-edit.component';
import { FundingDetailsComponent } from './components/funding/funding-details/funding-details.component';
import { FundingComponent } from './components/funding/funding/funding.component';
import { HomeComponent } from './components/home/home.component';
import { CreateInstitutionComponent } from './components/institutions/create-institution/create-institution.component';
import { EditInstitutionComponent } from './components/institutions/edit-institution/edit-institution.component';
import { InstitutionsComponent } from './components/institutions/institutions.component';
import { JobPostsCreateComponent } from "./components/job-posts/job-posts-create/job-posts-create.component";
import { JobPostsEditComponent } from "./components/job-posts/job-posts-edit/job-posts-edit.component";
import { JobPostsComponent } from "./components/job-posts/job-posts.component";
import { LoginComponent } from './components/login/login.component';
import { ChangePasswordComponent } from './components/manage/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/manage/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/manage/reset-password/reset-password.component';
import { NotificationEditComponent } from './components/notification/notification-edit/notification-edit.component';
import { NotificationComponent } from './components/notification/notification.component';
import { SendDialogComponent } from './components/notification/send-dialog/send-dialog.component';
import { TypesEditComponent } from './components/notification/types/types-edit/types-edit.component';
import { TypesComponent } from './components/notification/types/types.component';
import { PostTemplateCreateComponent } from './components/post-template/post-template-create/post-template-create.component';
import { PostTemplateEditComponent } from './components/post-template/post-template-edit/post-template-edit.component';
import { PostTemplateComponent } from './components/post-template/post-template.component';
import { RedeemerComponent } from './components/rewards/redeemer/redeemer.component';
import { RewardsCreateComponent } from './components/rewards/rewards-create/rewards-create.component';
import { RewardsEditComponent } from './components/rewards/rewards-edit/rewards-edit.component';
import { RewardsComponent } from './components/rewards/rewards.component';
import { InterestsCreateComponent } from './components/sales/interests/interests-create/interests-create.component';
import { InterestsEditComponent } from './components/sales/interests/interests-edit/interests-edit.component';
import { InterestsComponent } from './components/sales/interests/interests.component';
import { JobAdmitionComponent } from './components/sales/job-admition/job-admition/job-admition.component';
import { JobRequestsEditComponent } from './components/sales/job-requests/job-requests-edit/job-requests-edit.component';
import { JobRequestsComponent } from './components/sales/job-requests/job-requests/job-requests.component';
import { LeftMenuComponent } from './components/shared/left-menu/left-menu.component';
import { SubscriptionPlanEditComponent } from './components/subscriptions/plans/subscription-plan-edit/subscription-plan-edit.component';
import { SubscriptionPlansComponent } from './components/subscriptions/plans/subscription-plans.component';
import { TagsComponent } from './components/tags/tags.component';
import { TeamsComponent } from './components/teams/teams.component';
import { TendersCreateComponent } from './components/tenders/tenders-create/tenders-create.component';
import { TendersEditComponent } from './components/tenders/tenders-edit/tenders-edit.component';
import { TendersComponent } from './components/tenders/tenders.component';
import { UsersCreateComponent } from './components/users/users-create/users-create.component';
import { UsersEditComponent } from './components/users/users-edit/users-edit.component';
import { UsersComponent } from './components/users/users.component';
import { VerifyPhoneComponent } from './components/users/verify-phone/verify-phone.component';
import { EditorDisplayComponent } from './components/utility/editor-display/editor-display.component';
import { EditorToolbarComponent } from './components/utility/editor-toolbar/editor-toolbar.component';
import { InfoTileComponent } from './components/utility/info-tile/info-tile.component';
import { LoaderComponent } from './components/utility/loader/loader.component';
import { ProgressComponent } from "./components/utility/loader/progress.component";
import { ShareButtonsComponent } from './components/utility/share-buttons/share-buttons.component';
import { EqualValidator } from "./directives/equal-validator.directive";
import { OptionalDirective } from "./directives/optional.directive";
import { ShowHideInput } from "./directives/show-hide.directive";
import { AdminGuard } from './guards/admin.gaurd';
import { AuthGuard } from './guards/auth.guard';
import { CurrencyPipe } from "./pipes/currency.pipe";
import { LoadingPipe } from "./pipes/loading.pipe";
import { RoundPipe } from './pipes/round.pipe';
import { SafeDatePipe } from './pipes/safe-date.pipe';
import { Safe } from './pipes/safeHtml.pipe';
import { YesNoPipe } from './pipes/yesno.pipe';
import { RoutingModule } from './routing/routing.module';
import { AdminService } from './services/admin/admin.service';
import { QuestionService } from './services/assessment/question.service';
import { AssetService } from './services/asset.service';
import { AuthenticationService } from './services/authentication/authentication.service';
import { BookService } from './services/book.service';
import { AdvertService } from './services/business/advert.service';
import { BusinessService as BusinessCategoryService } from "./services/business/business-category.service";
import { InterestsService } from './services/business/interests.service';
import { JobAdmitionService } from './services/business/job-admition.service';
import { JobPostService } from "./services/business/job-post.service";
import { JobRequestService } from './services/business/job-request.service';
import { TenderService } from "./services/business/tender.service";
import { CampaignService } from "./services/campaign.service";
import { CouponService } from './services/coupon/coupon.service';
import { EventsService } from "./services/events.service";
import { FlashCouponService } from "./services/flash/flash-coupon-service";
import { FlashService } from './services/flash/flash.service';
import { FundingRequestService } from './services/funding/funding-request.service';
import { InstitutionService } from './services/institution.service';
import { LoggingService } from './services/logging/logging.service';
import { NotificationService } from "./services/notifications/NotificationService";
import { NotificationTypeService } from "./services/notifications/notification.service";
import { PostTemplateService } from './services/post-template.service';
import { RewardsService } from './services/rewards/rewards.service';
import { SearchService } from "./services/search/search.service";
import { SubscriptionFeaturesService } from './services/subscription-features.service';
import { SubscriptionPlanService as SubscriptionService } from './services/subscription.service';
import { StorageService } from './services/system/storage.service';
import { TagsService } from './services/tags.service';
import { TeamsService } from "./services/teams/team.service";
import { UserService } from './services/user/user.service';
import { AdvertOrderComponent } from './components/advert-order/advert-order.component';
import { AdvertOrderService } from './services/business/advert-order.service';
import { AdvertOrderEditComponent } from './components/advert-order/advert-order-edit/advert-order-edit.component';
import { AdsPricingComponent } from './components/ads-pricing/ads-pricing.component';
import { CreateAdsCouponComponent } from './components/ads-coupons/create-ads-coupon/create-ads-coupon.component';
import { AdsCouponsComponent } from './components/ads-coupons/ads-coupons.component';
import { AdsCouponsService } from './services/business/ads-coupons.service';
import { InvoiceThemeService } from './services/invoice-theme/invoice-theme.service';
import { CreateInvoiceThemeComponent } from './components/invoice-themes/create-invoice-theme/create-invoice-theme.component';
import { InvoiceThemesComponent } from './components/invoice-themes/invoice-theme.component';
import { EditInvoiceThemeComponent } from './components/invoice-themes/edit-invoice-theme/edit-invoice-theme.component';
import { BoardThemesComponent } from './components/board-themes/board-themes.component';
import { EditBoardThemeComponent } from './components/board-themes/edit-board-theme/edit-board-theme.component';
import { CreateBoardThemeComponent } from './components/board-themes/create-board-theme/create-board-theme.component';
import { BoardThemeService } from './services/board-themes/board-themes.service';
import { CompetitionsComponent } from './components/competitions/competitions.component';
import { CreateCompetitionComponent } from './components/competitions/create-competition/create-competition.component';
import { EditCompetitionComponent } from './components/competitions/edit-competition/edit-competition.component';
import { CompetitionService } from './services/competition/competition.service';
import { ProgramsComponent } from './components/reporting/programs/programs.component';
import { ProgramsCreateComponent } from './components/reporting/programs/programs-create/programs-create.component';
import { ProgramService } from "./services/program.service";
import { AppReleaseService } from './services/app-release.service';
import { CreateReleaseComponent } from './components/app-release/create-release/create-release.component';
import { AppReleaseComponent } from './components/app-release/app-release.component';
import { PlatformNamePipe } from './pipes/platformName.pipe';
import { EditReleaseComponent } from './components/app-release/edit-release/edit-release.component';
import { MarketplaceCouponsService } from './services/coupon/marketplace-coupon.service';
import { MarketplaceCoupons } from './components/marketplace-coupons/marketplace-coupons.component';
import { MarketplaceCouponsEditComponent } from './components/marketplace-coupons/coupons-edit/coupons-edit.component';
import { MarketplaceCouponsCreateComponent } from './components/marketplace-coupons/coupons-create/coupons-create.component';
import { CourierServicesComponent } from './components/courier-services/courier-services.component';
import { CouriersService } from './services/courier-services/couriers.service';
import { EditCourierComponent } from './components/courier-services/edit/edit-courier/edit-courier.component';
import { EditPackageComponent } from './components/courier-services/edit/edit-package/edit-package.component';
import { CreatePackageComponent } from './components/courier-services/edit/create-package/create-package.component';
import { CreateCourierComponent } from './components/courier-services/edit/create-courier/create-courier.component';
import { ListingCategoryGroupComponent } from './components/listing-categories/listing-category-group.component';
import { ListingCategoryService } from './services/listing-categories/listing-category.service';
import { EditCategoryGroupComponent } from './components/listing-categories/edit/edit-group/edit-category-group.component';
import { EditListingCategoryComponent } from './components/listing-categories/edit/edit-category/edit-listing-category.component';
import { CreateCategoryGroupComponent } from './components/listing-categories/create/create-group/create-category-group.component';
import { CreateListingCategoryComponent } from './components/listing-categories/create/create-category/create-listing-category.component';
import { ListingOptionComponent } from './components/listing-option/listing-option.component';
import { ListingOptionsService } from './services/listing-options.service';
import { EditListingOptionComponent } from './components/listing-option/edit/option/edit-listing-option.component';
import { CreateListingOptionComponent } from './components/listing-option/create/option/create-listing-option.component';
import { EventsComponent } from './components/events/events.component';
import { ProgrammeServiceService } from './components/programme-stats/programme-service.service';
import { ProgrammeStatsComponent } from './components/programme-stats/programme-stats.component';

export class MyHammerConfig extends HammerGestureConfig {
	overrides = <any>{
		// override hammerjs default configuration
		'press': { time: 1, threshold: 100 }
	};
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        LoginComponent,
        LoaderComponent,
        ProgressComponent,
        UsersComponent,
        UsersCreateComponent,
        UsersEditComponent,
        LeftMenuComponent,
        PageNotFoundComponent,
        EqualValidator,
        ShowHideInput,
        ChangePasswordComponent,
        OptionalDirective,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        UploadComponent,
        YesNoPipe,
        PlatformNamePipe,
        Safe,
        CurrencyPipe,
        EditorToolbarComponent,
        EditorDisplayComponent,
        RoundPipe,
        AppSideBarComponent,
        AppSideBarTabContentComponent,
        AppTopBarComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        AccessDeniedComponent,
        AccessDeniedFullComponent,
        AdminDashboardComponent,
        ManageFeedbackComponent,
        WeeklyDashboardComponent,
        VerifyPhoneComponent,
        ShareButtonsComponent,
        BusinessCategoryComponent,
        BusinessCategoryCreateComponent,
        BusinessCategoryEditComponent,
        BusinessProfileCreateComponent,
        TendersComponent,
        TendersCreateComponent,
        TendersEditComponent,
        JobPostsComponent,
        JobPostsCreateComponent,
        JobPostsEditComponent,
        SendDialogComponent,
        InfoTileComponent,
        EventEditComponent,
        JobRequestsComponent,
        JobAdmitionComponent,
        JobRequestsEditComponent,
        AdvertsComponent,
        AdvertOrderComponent,
        AdvertOrderEditComponent,
        AdvertsCreateComponent,
        AdvertsEditComponent,
        InterestsComponent,
        InterestsCreateComponent,
        InterestsEditComponent,
        UserDashboardComponent,
        LoadingPipe,
        BusinessProfileComponent,
        FundingComponent,
        TypesComponent,
        TypesEditComponent,
        RewardsComponent,
        RewardsCreateComponent,
        RewardsEditComponent,
        RedeemerComponent,
        FundingDetailsComponent,
        TagsComponent,
        CategoryGroupComponent,
        CategoryGroupCreateComponent,
        CategoryGroupEditComponent,
        NotificationComponent,
        NotificationEditComponent,
        TeamsComponent,
        BookComponent,
        FlashProductGroupComponent,
        FlashProductComponent,
        BookCreateComponent,
        BookEditComponent,
        SubscriptionPlansComponent,
        SubscriptionPlanEditComponent,
        HomeComponent,
        CampaignsComponent,
        CampaignsCreateComponent,
        CampaignsEditComponent,
        PostTemplateComponent,
        PostTemplateCreateComponent,
        EditFlashGroupComponent,
        FlashProductEditComponent,
        PostTemplateEditComponent,
        CouponsComponent,
        CouponsCreateComponent,
        CouponsEditComponent,
        SafeDatePipe,
        InstitutionsComponent,
        CreateInstitutionComponent,
        EditInstitutionComponent,
        FlashCouponsComponent,
        CreateFlashCouponComponent,
        EditFlashCouponComponent,
        AssetComponent,
        CreateAssetComponent,
        EditAssetComponent,
        AdsPricingComponent,
        CreateAdsCouponComponent,
        AdsCouponsComponent,
        CreateInvoiceThemeComponent,
        EditInvoiceThemeComponent,
        InvoiceThemesComponent,
        BoardThemesComponent,
        EditBoardThemeComponent,
        CreateBoardThemeComponent,
        CompetitionsComponent,
        CreateCompetitionComponent,
        EditCompetitionComponent,
        ProgramsComponent,
        ProgramsCreateComponent,
        CreateReleaseComponent,
        AppReleaseComponent,
        EditReleaseComponent,
        MarketplaceCoupons,
        MarketplaceCouponsEditComponent,
        MarketplaceCouponsCreateComponent,
        CourierServicesComponent,
        EditCourierComponent,
        EditPackageComponent,
        CreatePackageComponent,
        CreateCourierComponent,
        ListingCategoryGroupComponent,
        EditCategoryGroupComponent,
        EditListingCategoryComponent,
        CreateCategoryGroupComponent,
        CreateListingCategoryComponent,
        ListingOptionComponent,
        CreateListingOptionComponent,
        EditListingOptionComponent,
        EventsComponent,
        ProgrammeStatsComponent
    ],
    imports: [
        BrowserModule,
        NgxGaugeModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        RoutingModule,
        MomentModule,
        DataTableModule,
        PanelModule,
        SharedModule,
        AutoCompleteModule,
        DropdownModule,
        ButtonModule,
        MessagesModule,
        MessageModule,
        InputTextModule,
        MatSidenavModule,
        LayoutModule,
        FileUploadModule,
        ConfirmDialogModule,
        ListboxModule,
        TabMenuModule,
        SlideMenuModule,
        MegaMenuModule,
        MenuModule,
        InputMaskModule,
        CheckboxModule,
        SelectButtonModule,
        DialogModule,
        PasswordModule,
        TreeModule,
        ToolbarModule,
        DataViewModule,
        ContextMenuModule,
        TooltipModule,
        InputTextareaModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        CardModule,
        EditorModule,
        TabViewModule,
        CalendarModule,
        ClipboardModule,
        ScrollPanelModule,
        StepsModule,
        GrowlModule,
        ChartModule,
        TriStateCheckboxModule,
        ColorPickerModule,
        MultiSelectModule,
        InputSwitchModule,
        CarouselModule,
        OverlayPanelModule,
        OrderListModule,
        MatSlideToggleModule,
        ToggleButtonModule,
        ChipsModule,
        SliderModule,
        ReactiveFormsModule,

    ],
    providers: [
        AppComponent,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        AuthGuard,
        AdminGuard,
        AuthenticationService,
        ConfirmationService,
        UserService,
        LoggingService,
        StorageService,
        SearchService,
        AdminService,
        TreeDragDropService,
        FeedbackService,
        QuestionService,
        BusinessCategoryService,
        TenderService,
        JobPostService,
        EventsService,
        JobAdmitionService,
        JobRequestService,
        AdvertService,
        AdvertOrderService,
        InterestsService,
        FundingRequestService,
        NotificationTypeService,
        RewardsService,
        TagsService,
        NotificationService,
        TeamsService,
        BookService,
        SubscriptionService,
        SubscriptionFeaturesService,
        CampaignService,
        FlashService,
        PostTemplateService,
        CouponService,
        InstitutionService,
        AssetService,
        FlashCouponService,
        AdsCouponsService,
        InvoiceThemeService,
        BoardThemeService,
        CompetitionService,
        ProgramService,
        AppReleaseService,
        MarketplaceCouponsService,
        CouriersService,
        ListingCategoryService,
        ListingOptionsService,
        ProgrammeServiceService
    ],
    exports: [
        LoaderComponent,
        RewardsComponent,
        AppTopBarComponent
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts